import createHistory from "history/createHashHistory";

export default createHistory();



// WEBPACK FOOTER //
// ./src/common/history.js